import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { SiteProvider } from "./context/SiteContext";
import AdminPage from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";
import Nav from "./components/site/Nav";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import Devices from "./components/site/Devices";
import Packages from "./components/site/Packages";
import Coverage from "./components/site/Coverage";
import Setup from "./components/site/Setup";
import Faq from "./components/site/Faq";
import Categories from "./components/site/Categories";
import Reviews from "./components/site/Reviews";
import LiveAlert from "./components/site/LiveAlert";
import BigMatchCountdown from "./components/site/BigMatchCountdown";
import WeekCalendar from "./components/site/WeekCalendar";
import { useMatches, useBigMatches } from "./hooks/useMatches";
import Footer from "./components/site/Footer";
import FloatingWa from "./components/site/FloatingWa";

function Landing() {
  const [lenis, setLenis] = useState(null);
  const matches = useMatches();
  const big = useBigMatches(matches);

  useEffect(() => {
    const l = new Lenis({ duration: 1.2, smoothWheel: true });
    let id;
    const raf = (t) => { l.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    setLenis(l);
    return () => { cancelAnimationFrame(id); l.destroy(); };
  }, []);

  const go = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="grain min-h-screen bg-[#08072a]">
      <Nav go={go} ticker={<WeekCalendar list={big} />} />
      <LiveAlert matches={big} />
      <main>
        <Hero go={go} />
        <BigMatchCountdown matches={big} />
        <Marquee />
        <Devices />
        <Categories />
        <Packages />
        <Coverage />
        <Setup />
        <Reviews />
        <Faq />
      </main>
      <Footer go={go} />
      <FloatingWa />
      <Toaster />
    </div>
  );
}

export default function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </SiteProvider>
  );
}
